import React from 'react';
import { ContextMenuItem } from '@axiom/ui';

import type { WorkspaceFilterKeys, WorkspaceFilters } from './workspace.types';

const handleStageFilterUpdate = (
  existingStageFilters: string[],
  value: string
) => {
  return existingStageFilters.includes(value)
    ? existingStageFilters.filter(v => v !== value)
    : [...existingStageFilters, value];
};

export const WorkspaceContextMenuItems = ({
  filters,
  setFilters,
  values,
  updateKey,
}: {
  filters: WorkspaceFilters;
  setFilters: (newFilters: WorkspaceFilters) => void;
  values: string[];
  updateKey: WorkspaceFilterKeys;
}) => {
  const key = updateKey as keyof typeof filters;

  return (
    <>
      {values.map(value => (
        <ContextMenuItem
          name={`${value.replaceAll(' ', '_').toUpperCase()}_FILTER_OPTION`}
          key={value}
          onClick={() => {
            if (key === 'stage') {
              setFilters({
                ...filters,
                stage: handleStageFilterUpdate(filters.stage, value),
              });
            } else {
              setFilters({ ...filters, type: value });
            }
          }}
          selected={filters[key].includes(value)}
        >
          {value}
        </ContextMenuItem>
      ))}
    </>
  );
};
